import { render, staticRenderFns } from "./SellerAdd.vue?vue&type=template&id=96572400&scoped=true&"
import script from "./SellerAdd.vue?vue&type=script&lang=js&"
export * from "./SellerAdd.vue?vue&type=script&lang=js&"
import style0 from "./SellerAdd.vue?vue&type=style&index=0&id=96572400&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96572400",
  null
  
)

export default component.exports